import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/shared/services/HttpClientServices/Http.service';

@Injectable({
  providedIn: 'root'
})
export class RefreshTokenService {

  constructor(private http: HttpService) { }
  
  public tryRefreshingTokens(): any  {
    const refreshToken: string = localStorage.getItem("refreshToken");
    const credentials = { RefreshToken: refreshToken };
    var HttpHeader = {skip:"true"};
    return this.http.add("api/Authenticate/refresh", credentials,HttpHeader)
  }
}
